






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<Tag>({
  components: {},
})
export default class Tag extends Vue {
  @Prop({ type: String, required: true })
  private text!: string;
  @Prop({ type: String, required: true })
  private color!: string;
  @Prop({ type: String, required: false, default: '#ffffff' })
  private textColor!: string;
}
